// extracted by mini-css-extract-plugin
export default {"accordion_root":"Oca","accordion_summary":"Pca","accordion_details_root":"Qca","expand_icon":"Rca","rotate_arrow":"Sca","info_item":"Tca","ingredient":"Uca","title":"Vca","product":"Wca","img":"Xca"};
    if(module.hot) {
      // 1743628931597
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  